"use strict";

exports.__esModule = true;
var _AccessCheck = require("./AccessCheck");
Object.keys(_AccessCheck).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AccessCheck[key]) return;
  exports[key] = _AccessCheck[key];
});